import { getUploadTimes, getWorkspaceFileList, uploadFile, removeKey, renameKey, reloadKey, getKeyStatus, setSignOffFlag, setValidationFlag, setFileWeight } from '@/services'
import { readFileAsync, convertFileToItem } from '@/utils/file'
import path from 'path'

const file = {
  state: {
    files: [],
    sortPath: 'key',
    filterFunction: null,
    searchFunction: null,
    timeMapping: {}
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_FILES: (state, files) => {
      state.files = files
    },
    SET_TIMES: (state, timeMapping) => {
      state.timeMapping = timeMapping
    },
    SET_FILE: (state, file) => {
      const index = state.files.findIndex(x => x.key === file.key)
      state.files.splice(index, 1, file)
    },
    UPDATE_FILE: (state, file) => {
      const index = state.files.findIndex(x => x.key === file.key)
      if (index > -1) {
        state.files.splice(index, 1, file)
      } else {
        state.files.push(file)
      }
    },
    DELETE_FILE: (state, key) => {
      const index = state.files.findIndex(x => x.key === key)
      if (index > -1) {
        state.files.splice(index, 1)
      }
    },
    RENAME_FILE: (state, { key, newKey }) => {
      const index = state.files.findIndex(x => x.key === key)
      state.files[index].key = newKey
    },
    SET_SORT_PATH: (state, sortPath) => {
      state.sortPath = sortPath
    },
    SET_FILTER_FUNCTION: (state, filterFunction) => {
      state.filterFunction = filterFunction
    },
    SET_SEARCH_FUNCTION: (state, searchFunction) => {
      state.searchFunction = searchFunction
    },

    SET_FILE_SIGN_OFF_FLAG: (state, { key, stepName, signOff }) => {
      const index = state.files.findIndex(x => x.key === key)
      if (index > -1) {
        const file = state.files[index]
        file[stepName].signoff = signOff
        state.files.splice(index, 1, file)
      }
    },
    SET_FILE_VALIDATION_FLAG: (state, { key, stepName, validation }) => {
      const index = state.files.findIndex(x => x.key === key)
      if (index > -1) {
        const file = state.files[index]
        file[stepName].validation = validation
        state.files.splice(index, 1, file)
      }
    },
    SET_FILE_WEIGHT: (state, { key, stepName, weight }) => {
      const index = state.files.findIndex(x => x.key === key)
      if (index > -1) {
        const file = state.files[index]
        file[stepName].weight = weight
        state.files.splice(index, 1, file)
      }
    }
  },
  actions: {
    async FetchFiles ({ commit, dispatch }, workspace) {
      const { data } = await getWorkspaceFileList(workspace)
      const steps = await dispatch('GetSteps', workspace)
      const files = (data || [])
        .sort((a, b) => a.key.localeCompare(b.key))
        .map(file => convertFileToItem(steps, file))
      commit('SET_FILES', files)
    },

    async FetchUploadTimes ({ commit }, workspace) {
      const { data } = await getUploadTimes(workspace)
      commit('SET_TIMES', data)
    },

    async ReloadFile ({ commit, dispatch }, { workspace, key }) {
      const { data } = await reloadKey(workspace, key, 'clean|automate|infer')
      if (data === 'success') {
        const { data: file } = await getKeyStatus(workspace, key)
        const steps = await dispatch('GetSteps', workspace)
        const item = convertFileToItem(steps, file)
        commit('SET_FILE', item)
      }
    },

    async UploadFile ({ commit, dispatch }, { workspace, file, onProgress }) {
      if (onProgress) { onProgress({ percent: 1 }) }
      const dateBegin = new Date()
      let datePredict = 10
      const ext = path.extname(file.name)
      const key = path.basename(file.name, ext)
      const safeKey = key.replace(/[;/?:@=&<>#%{}|\\^~[\]`]/gi, '_').toLowerCase()
      const result = await readFileAsync(file)
      if (ext.match('pdf')) {
        datePredict = file.size / 18000
      }
      if (onProgress) {
        let progress = { percent: 1 }
        const intervalId = setInterval(() => {
          if (progress.percent <= 98) {
            let dateNow = new Date()
            let dateDiff = Math.ceil((dateNow.getTime() - dateBegin.getTime()) / 1000)
            progress.percent = Math.ceil(Math.atan(1.5 * dateDiff / datePredict) * 100)
            onProgress(progress)
          } else {
            clearInterval(intervalId)
          }
        }, 100)
      }
      const content = result.split('base64,')[1]
      const { data } = await uploadFile(workspace, safeKey, 'raw' + ext, content, 'clean|automate|infer')
      if (onProgress) { onProgress({ percent: 100 }) }
      const steps = await dispatch('GetSteps', workspace)
      const item = convertFileToItem(steps, data)
      commit('UPDATE_FILE', item)
    },

    async DeleteFile ({ commit }, { workspace, key }) {
      await removeKey(workspace, key)
      commit('DELETE_FILE', key)
    },

    async RenameFile ({ commit }, { workspace, key, newKey }) {
      await renameKey(workspace, key, newKey)
      commit('RENAME_FILE', { key, newKey })
    },

    async SetFileSignOffFlag ({ commit }, { workspace, key, stepName, signOff }) {
      await setSignOffFlag(workspace, key, stepName, signOff)
      commit('SET_FILE_SIGN_OFF_FLAG', { key, stepName, signOff })
    },

    async SetFileValidationFlag ({ commit }, { workspace, key, stepName, validation }) {
      await setValidationFlag(workspace, key, stepName, validation)
      commit('SET_FILE_VALIDATION_FLAG', { key, stepName, validation })
    },

    async SetFileWeight ({ commit }, { workspace, key, stepName, weight }) {
      await setFileWeight(workspace, key, stepName, weight)
      commit('SET_FILE_WEIGHT', { key, stepName, weight })
    }
  }
}

export default file
